import { Box } from '@mui/material';
import { Children, forwardRef } from 'react';
import { List } from 'react-window';

// mostly https://material-ui.com/components/autocomplete/#virtualization
const LISTBOX_PADDING = 8; // px

export const VirtualisedListbox = forwardRef(
  function VirtualisedListbox(props, ref) {
    const { children, styles, renderRow, ...other } = props;
    const itemData = Children.toArray(children);
    const itemCount = itemData.length;
    const itemSize = 40;
    const height = Math.min(10, itemCount) * itemSize;

    return (
      <Box ref={ref}>
        <List
          {...other}
          tagName="ul"
          style={{
            height: height + 2 * LISTBOX_PADDING,
            width: '100%',
            margin: 0,
            padding: 0,
          }}
          rowComponent={renderRow}
          rowProps={{ data: { ...itemData, styles } }}
          rowHeight={itemSize}
          overscanCount={5}
          rowCount={itemCount}
        />
      </Box>
    );
  },
);
